import { render } from "./GoodsCanvas.vue?vue&type=template&id=77afe333&scoped=true"
import script from "./GoodsCanvas.vue?vue&type=script&lang=js"
export * from "./GoodsCanvas.vue?vue&type=script&lang=js"

import "./GoodsCanvas.vue?vue&type=style&index=0&id=77afe333&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77afe333"]])

export default __exports__